import React, { useState, useEffect, useCallback } from 'react';
import { Button, InputNumber, Form, Input, message, Select } from 'antd';
import _debounce from 'lodash/debounce';

import { storeBurn, storeMint, getExchangeUsers } from '../../common/fetch';

const { Item } = Form;
const { TextArea } = Input;
const { Option } = Select;

const Burn = ({ type = 'burn', coinFormData = {}, onClose, exchangeUsers, form, exchange }) => {
    const [dataSource, setDataSource] = useState([])
    const { getFieldDecorator } = form;
    const getAllUsers = useCallback(async (params = {}) => {
        try {
            const res = await getExchangeUsers(exchange.id, params);
            if (res.data && res.data.data) {
                const exchangeUsers = res.data.data || [];
                setDataSource(exchangeUsers)
            }
        } catch (error) {
            console.log('error', error);
        }
    }, [exchange.id]);

    useEffect(() => {
        getAllUsers()
    }, [getAllUsers]);

    const handleSubmit = (e) => {
        e.preventDefault();
        const { getFieldsValue, validateFields } = form;
        validateFields((err) => {
            if (!err) {
                let body = getFieldsValue();
                const { amount, user_id, description } = body;
                const formProps = {
                    currency: coinFormData.symbol,
                    amount,
                    description,
                    user_id: user_id ? parseInt(user_id, 10) : user_id
                }
                if (type === 'mint') {
                    handleMint(formProps);
                    onClose();
                } else {
                    handleBurn(formProps);
                    onClose();
                }
            }
        });
    }

    const handleBurn = async (formValues) => {
        try {
            const res = await storeBurn(formValues);
            if (res.data) {
                message.success(`${res.data.amount} ${res.data.currency} successfully burnt`)
            }
        } catch (error) {
            if (error.data && error.data.message) {
                message.error(error.data.message);
            }
        }
    };

    const handleMint = async (formValues) => {
        try {
            const res = await storeMint(formValues);
            if (res.data) {
                message.success(`${res.data.amount} ${res.data.currency} successfully minted and allocated to user`)
            }
        } catch (error) {
            if (error.data && error.data.message) {
                message.error(error.data.message);
            }
        }
    };

    const searchUser = (searchText) => {
        getAllUsers({ search: searchText });
    };

    const handleSearch = _debounce(searchUser, 1000);

    const checkEmail = (rule, value, callback) => {
        let baseData = dataSource;
        let emailData = baseData.filter(data => data.id === parseInt(value, 10));
        if (!emailData.length) {
            callback("User doesn't exists");
        } else {
            callback();
        }
    };

    return (
        <div className='burn-wrapper'>
            <div className="title">{type === 'burn' ? 'Burn' : 'Mint'}</div>
            <div>
                {type === 'burn'
                    ? 'Burning will reduce the supply of the asset in existence.'
                    : 'Minting will create new supply of the asset into existence.'
                }
            </div>
            {/* <div className="edit-wrap">
                <div className="d-flex align-items-center">
                    <div>
                        <Coins
                            nohover
                            large
                            small
                            type={(coinFormData.symbol || '').toLowerCase()}
                            fullname={coinFormData.fullname}
                            color={
                                coinFormData.meta
                                ? coinFormData.meta.color
                                : ''
                            }
                        />
                    </div>
                    <div className="burn-content">
                        <div className="md-field-wrap">
                            <span className="sub-title">Amount:</span>
                            <InputNumber
                                onChange={(val) => {
                                    if (type === 'burn') {
                                        handleChangeNumber(val, 'burn')
                                    } else {
                                        handleChangeNumber(val, 'mint')
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="btn-wrapper">
                <Button type="primary" onClick={type === 'mint' ? handleMint : handleBurn}>
                    Next
                </Button>
            </div> */}
            <Form onSubmit={handleSubmit}>
                <Item className="type_wrapper">
                    <h3>Amount</h3>
                    {getFieldDecorator('amount', {
                        rules: [
                            {
                                required: true,
                                message: 'Please enter the amount'
                            }
                        ]
                    })(<InputNumber placeholder='Amount' />)}
                </Item>
                <Item className='type_wrapper'>
                    <h3>Email</h3>
                    {getFieldDecorator('user_id', {
                        rules: [
                            {
                                required: true,
                                message: 'Please input email'
                            },
                            {
                                validator: checkEmail
                            }
                        ]
                    })(
                        <Select
                            showSearch
                            placeholder="Select an user"
                            className="user-search-field"
                            onSearch={(text) => handleSearch(text)}
                            filterOption={() => true}
                        >
                            {dataSource.map((sender) => (
                                <Option key={sender.id}>{sender.email}</Option>
                            ))}
                        </Select>
                    )}
                </Item>
                <Item className='type_wrapper'>
                    <h3>Description</h3>
                    {getFieldDecorator('description')(
                        <TextArea
                            placeholder="description"
                            rows={3}
                        />
                    )}
                </Item>
                <Button type='primary' htmlType='submit'>
                    Proceed
                </Button>
            </Form>
        </div>
    );
}
const BurnModal = Form.create({
    name: 'MintBurn'
})(Burn);

export default BurnModal;
